<template>
  <router-view></router-view>
</template>

<script>
  import { mapActions} from 'vuex';
  export default {
    name: 'app',
    methods:{
      ...mapActions({
        getSys:'setting/getSysAction',
        getMonths: 'setting/getMonthsAction',
        getRooms: 'setting/getRoomsAction',
        getNcutRooms: 'setting/getNcutRoomsAction',
      }),
    },
    async created() {
      await this.getSys();
      await this.getMonths();
      await this.getRooms();
      //await this.getNcutRooms();
    }
  }
</script>